import { EmailApi, IEmail } from 'api/EmailApi';
import { useAppSettingsSlice } from 'app/slice';
import { translations } from 'locales/translations';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export const useSendMail = () => {
  const dispatch = useDispatch();
  const { actions } = useAppSettingsSlice();
  const { t } = useTranslation();
  return useCallback(
    (email: IEmail) => {
      try {
        EmailApi.SendEmail(email)
          .then(v => {
            //console.log(v);
            dispatch(
              actions.addNotification({
                variant: v ? 'success' : 'error',
                message: t(
                  v
                    ? translations.msg_EmailSent
                    : translations.msg_EmailSendingFailed,
                ),
              }),
            );
          })
          .catch(e => {
            //console.log(e);
            dispatch(
              actions.addNotification({
                variant: 'error',
                message: e,
              }),
            );
          });
      } catch (e) {
        //console.log(e);
        console.error(e);
      }
    },
    [actions, dispatch, t],
  );
};
